<div mat-dialog-title class="flex-container">
    <button mat-button class="close" [mat-dialog-close]="true">
      <mat-icon>close</mat-icon>
    </button>
    <h1>Manage NursePractitioner - {{assignedNP.firstName}} {{assignedNP.lastName}}</h1>
  </div>
  <div mat-dialog-content>
    <form [formGroup]="_assignForm">

        <div class="row">
            <div class="col-lg-6">
              <p>Select Client<span>*</span></p>
              <mat-form-field appearance="none" class="manage-select">
                <mat-select formControlName="clientIds" (selectionChange)="getProjectsByClient($event)"
                  placeholder="Select Client" multiple required>
                  <mat-option *ngFor="let client of clients"  [value]="client.clientId">{{ client.clientName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-lg-6">
              <p>Select Project<span>*</span></p>
              <mat-form-field appearance="none" class="manage-select">
                <mat-select formControlName="projectIds"  placeholder="Select Project" multiple required>
                  <mat-option *ngFor="let project of projects" [value]="project.projectId">{{ project.clientName }} - {{ project.projectName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- <div class="col-lg-2" *ngIf="disPlayReset">
                <button mat-raised-button mat-button
                  class="btn btn-icon-text3 md-button-right top-pad" [disabled]="!disableOptions" (click)="changeResetButton()">
                  RESET
                </button>
          </div> -->
        </div>

        <!-- <div class="row">
          <div *ngIf="assignedNps != null && assignedNps.length > 0" class="col-lg-12">
            <p>Assigned Nurse Practitioners</p>
            <ul style="padding: 0px;">
              <li class="priorityli" *ngFor="let s of assignedNps; let even = even; let odd = odd"
                [ngClass]="{ odd: odd, even: even }">{{s.firstName}}</li>
            </ul>
          </div>
        </div> -->

        <div class="row">
          <div *ngIf="selectedProjects != null && selectedProjects.length > 0" class="col-lg-12">
            <p>Assigned Client & Projects</p>
            <ul style="padding: 0px;">
              <li class="priorityli" *ngFor="let project of selectedProjects; let even = even; let odd = odd"
                [ngClass]="{ odd: odd, even: even }">{{project.projectName}}</li>
            </ul>
          </div>
        </div>

        <div class="row">
          <div *ngIf="!isAssigned" class="col-lg-12 toparea">
            <button n-submit mat-raised-button mat-button (click)="assign()" [disabled]="!_assignForm.valid"
              class="btn btn-icon-text3 md-button-right">
              UPDATE ASSIGNMENT
            </button>
          </div>
        </div>

    </form>
  </div>
